module.exports = __webpack_public_path__ + "img/leval-7.94afe807.png";